export default __webpack_public_path__ + "media/be56c6377eaeb484d4d6ef1b20e8d733bc5bf4a462da289de81df7c83fb9aba3.svg";